import { render } from "./registration_form.html?vue&type=template&id=425c63f5&external"
import script from "./registration_form.js?vue&type=script&lang=js&external"
export * from "./registration_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__